import React from 'react';

import { AutoOpenPaymentWidget } from '@/shared/components/AutoOpenPaymentWidget/AutoOpenPaymentWidget';
import { useAutoOpenPaymentWidgetParams } from '@/shared/hooks/useAutoOpenPaymentWidgetParams';

import { useMultiOfferSuccessPurchase } from '../../hooks/useMultiOfferSuccessPurchase';

export const AutoOpenPaymentWidgetOnHome = () => {
    const { billingFeatureName = '' } = useAutoOpenPaymentWidgetParams();

    const onSuccessPurchase = useMultiOfferSuccessPurchase({
        billingFeatureNames: [billingFeatureName],
    });

    return <AutoOpenPaymentWidget onSuccessPurchase={onSuccessPurchase} />;
};
